import React, { useState, useCallback } from "react"

export const withNewsletterPopup = Component => ({ name = "NewsletterPopup", newsletter }) => {
  Component.displayName = name

  const isBrowser = typeof window !== `undefined`
  const title = newsletter?.additionalTitle ? newsletter.additionalTitle : null
  const message = newsletter?.additionalMessage ? newsletter.additionalMessage : null

  const dismissed = isBrowser ? window.localStorage.getItem("theme:newsletter-dismissed") : null

  const [visible, setVisible] = useState(!dismissed && newsletter?.enabled)

  const dismiss = useCallback(() => {
    if (isBrowser) {
      window.localStorage.setItem("theme:newsletter-dismissed", "true")
      setVisible(false)
    }
  }, [isBrowser, setVisible])

  return visible && !dismissed ? <Component title={title} message={message} dismiss={dismiss} newsletter={newsletter} /> : null
}
